import { Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { TransactionData } from '../../interfaces/transaction/transaction-data';

@Injectable({
  providedIn: 'root',
})
export class TransactionCreditToTableDataMapper {

  public map(transactionData: TransactionData): DialogTableDataRow[] {

    /**
     * Transaction initialized/canceled = no refund data
     */
    if (transactionData.status === 'initialized' || transactionData.status === 'canceled') {
      return null;
    }

    if (transactionData?.creditPossible) {
      return [
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'CREDITAMOUNT',
          title: transactionData.currency,
          titleFormatPipe: 'AMOUNTCURRENCYLABEL',
          valueType: 'CREDITAMOUNT'
        }
     ]
    } else {
      return null;
    }

  }

}
